import { Link } from "react-router-dom";
import wordmark from "../assets/brand/wordmark_navy.png";

export default function Footer() {
  return (
    <footer
      className="w-full mt-10 border-t"
      style={{ borderColor: "hsl(var(--klareet-line-soft))", background: "hsl(var(--klareet-canvas-2))" }}
      data-testid="klareet-footer"
    >
      <div className="max-w-6xl mx-auto px-5 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <img src={wordmark} alt="Klareet" className="h-5" />
          <span className="k-quiet">Your read is yours. Buyers see aggregates, never you.</span>
        </div>
        <div className="flex items-center gap-5 text-sm">
          <Link to="/" className="k-quiet hover:underline" data-testid="footer-start-link">Start</Link>
          <Link to="/grow" className="k-quiet hover:underline" data-testid="footer-grow-link">Grow</Link>
          <a
            href="mailto:hello@klareet.example"
            className="k-quiet hover:underline"
            data-testid="footer-support-link"
          >
            Support
          </a>
          <span className="k-quiet klareet-mono text-xs">© Klareet</span>
        </div>
      </div>
    </footer>
  );
}
